export { default } from './PlayerTTS';
